<template>
    <b-container>
        <b-row class="response-page error">
          <div class="card">
          <div style="border-radius:200px; height:200px; width:200px; background: #rgb(246 246 246); margin:0 auto;">
            <i class="checkmark">X</i>
          </div>
            <h1>Ödeme Başarısız.</h1> 
            <p>{{ message }}</p>
          </div>
        </b-row>
    </b-container>
</template>


<script>
  export default{
    data(){
      return{
      }
    },
    computed:{
      message(){
        return this.$route.query.message;
      },
      session(){
        return this.$route.query.sid;
      }
    },
    created(){
      
    },
  }
</script>
